<template>
  <div class="flex flex-col gap-14">
    <div>
      <h3 class="h3">Persönliche Daten</h3>
      <div class="default-grid sm:grid-cols-3">
        <div>
          <h4 class="h4">Vorname</h4>
          <input v-model="vorname" class="textfield"/>
        </div>
        <div>
          <h4 class="h4">Nachname</h4>
          <input v-model="nachname" class="textfield"/>
        </div>
        <div>
          <h4 class="h4">Geburtsdatum</h4>
          <VueDatePicker class="datepicker" v-model="birthdate" :month-change-on-scroll="false" :format="formatDate"/>
        </div>
      </div>
    </div>

    <div>
      <h3 class="h3">Anschrift</h3>
      <div>
        <div class="default-grid sm:grid-cols-2">
          <div>
            <h4 class="h4">Straße</h4>
            <input v-model="street" class="textfield"/>
          </div>
          <div>
            <h4 class="h4">Hausnummer</h4>
            <input v-model="housenumber" class="textfield"/>
          </div>
          <div>
            <h4 class="h4">Postleitzahl</h4>
            <input v-model="postalcode" class="textfield"/>
          </div>
          <div>
            <h4 class="h4">Ort</h4>
            <input v-model="city" class="textfield"/>
          </div>
          <div>
            <h4 class="h4">Land</h4>
            <select v-model="country" class="textfield">
                <option value="AUT" >Österreich</option>
                <option value="DEU">Deutschland</option>
                <option value="AFG">Afghanistan</option>
                <option value="EGY">Ägypten</option>
                <option value="ALB">Albanien</option>
                <option value="DZA">Algerien</option>
                <option value="AND">Andorra</option>
                <option value="AGO">Angola</option>
                <option value="ATG">Antigua und Barbuda</option>
                <option value="GNQ">Äquatorialguinea</option>
                <option value="ARG">Argentinien</option>
                <option value="ARM">Armenien</option>
                <option value="AZE">Aserbaidschan</option>
                <option value="ETH">Äthiopien</option>
                <option value="AUS">Australien</option>
                <option value="BHS">Bahamas</option>
                <option value="BHR">Bahrain</option>
                <option value="BGD">Bangladesch</option>
                <option value="BRB">Barbados</option>
                <option value="BEL">Belgien</option>
                <option value="BLZ">Belize</option>
                <option value="BEN">Benin</option>
                <option value="BTN">Bhutan</option>
                <option value="BOL">Bolivien</option>
                <option value="BIH">Bosnien Herzegowina</option>
                <option value="BWA">Botsuana</option>
                <option value="BRA">Brasilien</option>
                <option value="BRN">Brunei Darussalam</option>
                <option value="BGR">Bulgarien</option>
                <option value="BFA">Burkina Faso</option>
                <option value="BDI">Burundi</option>
                <option value="CHL">Chile</option>
                <option value="CHN">China</option>
                <option value="CRI">Costa Rica</option>
                <option value="CIV">Côte d'Ivoire</option>
                <option value="DNK">Dänemark</option>
                <option value="DMA">Dominica</option>
                <option value="DOM">Dominikanische Republik</option>
                <option value="DJI">Dschibuti</option>
                <option value="ECU">Ecuador</option>
                <option value="SLV">El Salvador</option>
                <option value="ERI">Eritrea</option>
                <option value="EST">Estland</option>
                <option value="FJI">Fidschi</option>
                <option value="FIN">Finnland</option>
                <option value="FRA">Frankreich</option>
                <option value="GAB">Gabun</option>
                <option value="GMB">Gambia</option>
                <option value="GEO">Georgien</option>
                <option value="GHA">Ghana</option>
                <option value="GRD">Grenada</option>
                <option value="GRC">Griechenland</option>
                <option value="GTM">Guatemala</option>
                <option value="GIN">Guinea</option>
                <option value="GNB">Guinea-Bissau</option>
                <option value="GUY">Guyana</option>
                <option value="HTI">Haiti</option>
                <option value="HND">Honduras</option>
                <option value="IND">Indien</option>
                <option value="IDN">Indonesien</option>
                <option value="IRQ">Irak</option>
                <option value="IRN">Iran</option>
                <option value="IRL">Irland</option>
                <option value="ISL">Island</option>
                <option value="ISR">Israel</option>
                <option value="ITA">Italien</option>
                <option value="JAM">Jamaika</option>
                <option value="JPN">Japan</option>
                <option value="YEM">Jemen</option>
                <option value="JOR">Jordanien</option>
                <option value="KHM">Kambodscha</option>
                <option value="CMR">Kamerun</option>
                <option value="CAN">Kanada</option>
                <option value="CPV">Kap Verde</option>
                <option value="KAZ">Kasachstan</option>
                <option value="QAT">Katar</option>
                <option value="KEN">Kenia</option>
                <option value="KGZ">Kirgisistan</option>
                <option value="KIR">Kiribati</option>
                <option value="COL">Kolumbien</option>
                <option value="COM">Komoren</option>
                <option value="COG">Kongo</option>
                <option value="COD">Kongo, Demokrat. Republik</option>
                <option value="PRK">Korea, Demokratische Republik</option>
                <option value="KOR">Korea, Republik</option>
                <option value="HRV">Kroatien</option>
                <option value="CUB">Kuba</option>
                <option value="KWT">Kuwait</option>
                <option value="LAO">Laos</option>
                <option value="LSO">Lesotho</option>
                <option value="LVA">Lettland</option>
                <option value="LBN">Libanon</option>
                <option value="LBR">Liberia</option>
                <option value="LBY">Libyen</option>
                <option value="LIE">Liechtenstein</option>
                <option value="LTU">Litauen</option>
                <option value="LUX">Luxemburg</option>
                <option value="MDG">Madagaskar</option>
                <option value="MWI">Malawi</option>
                <option value="MYS">Malaysia</option>
                <option value="MDV">Malediven</option>
                <option value="MLI">Mali</option>
                <option value="MLT">Malta</option>
                <option value="MAR">Marokko</option>
                <option value="MHL">Marshallinseln</option>
                <option value="MRT">Mauretanien</option>
                <option value="MUS">Mauritius</option>
                <option value="MEX">Mexiko</option>
                <option value="FSM">Mikronesien</option>
                <option value="MDA">Moldau</option>
                <option value="MCO">Monaco</option>
                <option value="MNG">Mongolei</option>
                <option value="MOZ">Mosambik</option>
                <option value="MMR">Myanmar</option>
                <option value="NAM">Namibia</option>
                <option value="NRU">Nauru</option>
                <option value="NPL">Nepal</option>
                <option value="NZL">Neuseeland</option>
                <option value="NIC">Nicaragua</option>
                <option value="NLD">Niederlande</option>
                <option value="NER">Niger</option>
                <option value="NGA">Nigeria</option>
                <option value="NOR">Norwegen</option>
                <option value="OMN">Oman</option>
                <option value="PAK">Pakistan</option>
                <option value="PLW">Palau</option>
                <option value="PAN">Panama</option>
                <option value="PNG">Papua-Neuguinea</option>
                <option value="PRY">Paraguay</option>
                <option value="PER">Peru</option>
                <option value="PHL">Philippinen</option>
                <option value="POL">Polen</option>
                <option value="PRT">Portugal</option>
                <option value="RWA">Ruanda</option>
                <option value="ROU">Rumänien</option>
                <option value="RUS">Russland</option>
                <option value="WSM">Samoa</option>
                <option value="SAU">Saudi-Arabien</option>
                <option value="SEN">Senegal</option>
                <option value="SRB">Serbien</option>
                <option value="SGP">Singapur</option>
                <option value="SVK">Slowakei</option>
                <option value="SVN">Slowenien</option>
                <option value="ZAF">Südafrika</option>
                <option value="ESP">Spanien</option>
                <option value="LKA">Sri Lanka</option>
                <option value="SDN">Sudan</option>
                <option value="SWE">Schweden</option>
                <option value="CHE">Schweiz</option>
                <option value="TZA">Tansania</option>
                <option value="THA">Thailand</option>
                <option value="TUN">Tunesien</option>
                <option value="TUR">Türkei</option>
                <option value="UGA">Uganda</option>
                <option value="UKR">Ukraine</option>
                <option value="ARE">Vereinigte Arabische Emirate</option>
                <option value="GBR">Vereinigtes Königreich</option>
                <option value="USA">Vereinigte Staaten</option>
                <option value="VEN">Venezuela</option>
                <option value="VNM">Vietnam</option>
                <option value="ZMB">Sambia</option>
                <option value="ZWE">Simbabwe</option>
                <option value="ZWE">Zypern</option>
            </select>
          </div>
          <div>
            <h4 class="h4">Staatsbürgerschaft</h4>
            <select v-model="citizenship" class="textfield">
                <option value="AUT" >Österreich</option>
                <option value="DEU">Deutschland</option>
                <option value="AFG">Afghanistan</option>
                <option value="EGY">Ägypten</option>
                <option value="ALB">Albanien</option>
                <option value="DZA">Algerien</option>
                <option value="AND">Andorra</option>
                <option value="AGO">Angola</option>
                <option value="ATG">Antigua und Barbuda</option>
                <option value="GNQ">Äquatorialguinea</option>
                <option value="ARG">Argentinien</option>
                <option value="ARM">Armenien</option>
                <option value="AZE">Aserbaidschan</option>
                <option value="ETH">Äthiopien</option>
                <option value="AUS">Australien</option>
                <option value="BHS">Bahamas</option>
                <option value="BHR">Bahrain</option>
                <option value="BGD">Bangladesch</option>
                <option value="BRB">Barbados</option>
                <option value="BEL">Belgien</option>
                <option value="BLZ">Belize</option>
                <option value="BEN">Benin</option>
                <option value="BTN">Bhutan</option>
                <option value="BOL">Bolivien</option>
                <option value="BIH">Bosnien Herzegowina</option>
                <option value="BWA">Botsuana</option>
                <option value="BRA">Brasilien</option>
                <option value="BRN">Brunei Darussalam</option>
                <option value="BGR">Bulgarien</option>
                <option value="BFA">Burkina Faso</option>
                <option value="BDI">Burundi</option>
                <option value="CHL">Chile</option>
                <option value="CHN">China</option>
                <option value="CRI">Costa Rica</option>
                <option value="CIV">Côte d'Ivoire</option>
                <option value="DNK">Dänemark</option>
                <option value="DMA">Dominica</option>
                <option value="DOM">Dominikanische Republik</option>
                <option value="DJI">Dschibuti</option>
                <option value="ECU">Ecuador</option>
                <option value="SLV">El Salvador</option>
                <option value="ERI">Eritrea</option>
                <option value="EST">Estland</option>
                <option value="FJI">Fidschi</option>
                <option value="FIN">Finnland</option>
                <option value="FRA">Frankreich</option>
                <option value="GAB">Gabun</option>
                <option value="GMB">Gambia</option>
                <option value="GEO">Georgien</option>
                <option value="GHA">Ghana</option>
                <option value="GRD">Grenada</option>
                <option value="GRC">Griechenland</option>
                <option value="GTM">Guatemala</option>
                <option value="GIN">Guinea</option>
                <option value="GNB">Guinea-Bissau</option>
                <option value="GUY">Guyana</option>
                <option value="HTI">Haiti</option>
                <option value="HND">Honduras</option>
                <option value="IND">Indien</option>
                <option value="IDN">Indonesien</option>
                <option value="IRQ">Irak</option>
                <option value="IRN">Iran</option>
                <option value="IRL">Irland</option>
                <option value="ISL">Island</option>
                <option value="ISR">Israel</option>
                <option value="ITA">Italien</option>
                <option value="JAM">Jamaika</option>
                <option value="JPN">Japan</option>
                <option value="YEM">Jemen</option>
                <option value="JOR">Jordanien</option>
                <option value="KHM">Kambodscha</option>
                <option value="CMR">Kamerun</option>
                <option value="CAN">Kanada</option>
                <option value="CPV">Kap Verde</option>
                <option value="KAZ">Kasachstan</option>
                <option value="QAT">Katar</option>
                <option value="KEN">Kenia</option>
                <option value="KGZ">Kirgisistan</option>
                <option value="KIR">Kiribati</option>
                <option value="COL">Kolumbien</option>
                <option value="COM">Komoren</option>
                <option value="COG">Kongo</option>
                <option value="COD">Kongo, Demokrat. Republik</option>
                <option value="PRK">Korea, Demokratische Republik</option>
                <option value="KOR">Korea, Republik</option>
                <option value="HRV">Kroatien</option>
                <option value="CUB">Kuba</option>
                <option value="KWT">Kuwait</option>
                <option value="LAO">Laos</option>
                <option value="LSO">Lesotho</option>
                <option value="LVA">Lettland</option>
                <option value="LBN">Libanon</option>
                <option value="LBR">Liberia</option>
                <option value="LBY">Libyen</option>
                <option value="LIE">Liechtenstein</option>
                <option value="LTU">Litauen</option>
                <option value="LUX">Luxemburg</option>
                <option value="MDG">Madagaskar</option>
                <option value="MWI">Malawi</option>
                <option value="MYS">Malaysia</option>
                <option value="MDV">Malediven</option>
                <option value="MLI">Mali</option>
                <option value="MLT">Malta</option>
                <option value="MAR">Marokko</option>
                <option value="MHL">Marshallinseln</option>
                <option value="MRT">Mauretanien</option>
                <option value="MUS">Mauritius</option>
                <option value="MEX">Mexiko</option>
                <option value="FSM">Mikronesien</option>
                <option value="MDA">Moldau</option>
                <option value="MCO">Monaco</option>
                <option value="MNG">Mongolei</option>
                <option value="MOZ">Mosambik</option>
                <option value="MMR">Myanmar</option>
                <option value="NAM">Namibia</option>
                <option value="NRU">Nauru</option>
                <option value="NPL">Nepal</option>
                <option value="NZL">Neuseeland</option>
                <option value="NIC">Nicaragua</option>
                <option value="NLD">Niederlande</option>
                <option value="NER">Niger</option>
                <option value="NGA">Nigeria</option>
                <option value="NOR">Norwegen</option>
                <option value="OMN">Oman</option>
                <option value="PAK">Pakistan</option>
                <option value="PLW">Palau</option>
                <option value="PAN">Panama</option>
                <option value="PNG">Papua-Neuguinea</option>
                <option value="PRY">Paraguay</option>
                <option value="PER">Peru</option>
                <option value="PHL">Philippinen</option>
                <option value="POL">Polen</option>
                <option value="PRT">Portugal</option>
                <option value="RWA">Ruanda</option>
                <option value="ROU">Rumänien</option>
                <option value="RUS">Russland</option>
                <option value="WSM">Samoa</option>
                <option value="SAU">Saudi-Arabien</option>
                <option value="SEN">Senegal</option>
                <option value="SRB">Serbien</option>
                <option value="SGP">Singapur</option>
                <option value="SVK">Slowakei</option>
                <option value="SVN">Slowenien</option>
                <option value="ZAF">Südafrika</option>
                <option value="ESP">Spanien</option>
                <option value="LKA">Sri Lanka</option>
                <option value="SDN">Sudan</option>
                <option value="SWE">Schweden</option>
                <option value="CHE">Schweiz</option>
                <option value="TZA">Tansania</option>
                <option value="THA">Thailand</option>
                <option value="TUN">Tunesien</option>
                <option value="TUR">Türkei</option>
                <option value="UGA">Uganda</option>
                <option value="UKR">Ukraine</option>
                <option value="ARE">Vereinigte Arabische Emirate</option>
                <option value="GBR">Vereinigtes Königreich</option>
                <option value="USA">Vereinigte Staaten</option>
                <option value="VEN">Venezuela</option>
                <option value="VNM">Vietnam</option>
                <option value="ZMB">Sambia</option>
                <option value="ZWE">Simbabwe</option>
                <option value="ZWE">Zypern</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h3 class="h3">Kontaktdaten</h3>
      <div class="default-grid sm:grid-cols-2">
        <div>
          <h4 class="h4">E-Mail Adresse</h4>
          <input v-model="email" class="textfield"/>
          <span v-if="emailInValid && email != null && email != ''" class="text-red-500 text-sm">E-Mail Adresse ungültig</span>
        </div>
        <div>
          <h4 class="h4">Telefonnummer</h4>
          <input v-model="phone" class="textfield"/>
        </div>
      </div>
    </div>
  </div>

  <div v-if="isDev" class="flex justify-between mt-5">
    <div></div>
    <input type="button" class="button dev mt-6" value="Fill demo data" @click="fill"/>
  </div>

  <div class="flex justify-between mt-5 items-center">
    <input type="button" class="button prev" :value="Navigation.ZURÜCK" @click="prev"/>
    <input type="button" class="button next" :disabled="nextDisabled" :value="Navigation.WEITER" @click="next"/>
  </div>
  <div class="text-center">
    <span class="!text-gray-200 !text-xs !font-sans">digital begeistert von <a href="https://www.codeandcomments.at" class="!underline !text-xs !text-gray-200 !font-sans">code & comments</a></span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { DetailStep, Navigation } from '../models/enums'
import { useStore } from 'vuex';
import { scrollToTop } from '@/models/helper';

const store = useStore();
const nextDisabled = computed(() => !store.getters.PI_IS_VALID);
const emailInValid = computed(() => !store.getters.PI_EMAIL_IS_VALID);
const isDev = store.state.isDev;

// Personal Data
const vorname = computed({
  get: () => store.state.pi.firstname,
  set: value => store.commit("updatePi", { key: "firstname", value })
});
const nachname = computed({
  get: () => store.state.pi.lastname,
  set: value => store.commit("updatePi", { key: "lastname", value })
});
const birthdate = computed({
  get: () => store.state.pi.birthdate,
  set: value => {
    store.commit("updatePi", { key: "birthdate", value })
  }
});

// Address
const street = computed({
  get: () => store.state.pi.street,
  set: value => store.commit("updatePi", { key: "street", value })
});
const housenumber = computed({
  get: () => store.state.pi.housenumber,
  set: value => store.commit("updatePi", { key: "housenumber", value })
});
const postalcode = computed({
  get: () => store.state.pi.postalcode,
  set: value => store.commit("updatePi", { key: "postalcode", value })
});
const city = computed({
  get: () => store.state.pi.city,
  set: value => store.commit("updatePi", { key: "city", value })
});
const country = computed({
  get: () => store.state.pi.country,
  set: value => store.commit("updatePi", { key: "country", value })
});
const citizenship = computed({
  get: () => store.state.pi.citizenship,
  set: value => store.commit("updatePi", { key: "citizenship", value })
});

// Contact
const email = computed({
  get: () => store.state.pi.email,
  set: value => store.commit("updatePi", { key: "email", value })
});
const phone = computed({
  get: () => store.state.pi.phone,
  set: value => store.commit("updatePi", { key: "phone", value })
});

const formatDate = (date) => date.toLocaleDateString();
const prev = () => {
  store.commit("stepBack");
  scrollToTop();
}
const next = () => {
  store.commit("updateStep", DetailStep.ÜBERPRÜFEN);
  scrollToTop();
}
const fill = () => {
  vorname.value = "Max";
  nachname.value = "Mustermann";
  birthdate.value = new Date();
  street.value = "Musterstraße";
  housenumber.value = "1";
  postalcode.value = "1111";
  city.value = "Musterstadt";
  country.value = "AUT";
  citizenship.value = "AUT";
  email.value = "max.mustermann@mustermail.com";
  phone.value = "+43123456789";
}
</script>

<style scoped lang="scss">
h3, h4 {
  @apply mb-2;
}
.typebutton {
  @apply border border-slate-300 bg-gray-100 cursor-pointer p-4 flex flex-col rounded-md select-none w-36;
  &.active {
    @apply bg-gray-300;
  }
}

.default-grid {
  @apply grid gap-3;
}
</style>
